import {
  ON_START_OFFERT_UPDATE_STATUS,ON_OFFERT_UPDATE_STATUS,ON_ERROR_OFFERT_UPDATE_STATUS,
  ON_OFFERT_UPDATE_STATUS_1,ON_OFFERT_UPDATE_STATUS_2,ON_OFFERT_UPDATE_STATUS_3,ON_OFFERT_UPDATE_STATUS_4,

  OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES,
  OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES_FROM_LS,
  OFFERTPREV_ON_LOAD_CURRENT_OFFERT,
  
  OFFERTPREV_ON_GET_ALL_OFFERTS,
  OFFERTPREV_ON_START_GET_ALL_OFFERTS,
  OFFERTPREV_ON_GET_AVTAL_OFFERTS,

  OFFERTPREV_ON_UPDATE_INPUT_FIELD,
  OFFERTPREV_ON_UPDATE_CHECKBOX,

  OFFERTPREV_ON_ADD_OFFERT,
  OFFERTPREV_ON_START_LOAD_OFFERT,
  OFFERTPREV_ON_LOAD_OFFERT,
  OFFERTPREV_ON_GET_OFFERTS,
  OFFERTPREV_ON_DELETE_OFFERT,
  OFFERTPREV_ON_UPDATE_OFFERT,
  OFFERTPREV_ON_MAP_INPUTS,
  OFFERTPREV_ON_UPDATE_MAP_INPUTS,
  OFFERTPREV_ON_SET_CUSTOMER,
  OFFERTPREV_LOAD_SELECTED_CUSTOMER,
  OFFERTPREV_ON_CHANGE_EDIT_TEXT,

  OFFERTPREV_ON_ADD_PRODUCT,
  OFFERTPREV_ON_CHANGE_AVTALSTID,
  OFFERTPREV_ON_DELETE_PRODUCT,
  OFFERTPREV_ON_CHANGE_PRODUCT_QNT,
  OFFERTPREV_ON_CHANGE_PRODUCT,
  OFFERTPREV_ON_LOAD_ARTIKLAR,
  OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR,
  OFFERTPREV_ON_START_LOAD_ARTIKLAR,
  OFFERTPREV_ON_SUM_TOTAL,
  OFFERTPREV_ON_GET_OFFERT_COUNT,

  OFFERTPREV_ON_RESPOSE,
  OFFERTPREV_ON_RESPOSE_RESET,

  OFFERTPREV_ON_SET_LOADING,
  OFFERTPREV_ON_SET_LOADING_DONE,
  OFFERTPREV_ON_GET_DOCUMENTS,
  OFFERTPREV_ON_SEARCH_OFFERTS,
  OFFERTPREV_ON_GET_STATS,
  OFFERTPREV_ON_FETCH_ART,
  OFFERTPREV_ON_START_SEARCH_ART,
  OFFERTPREV_ON_SEARCH_ART,
  OFFERTPREV_ON_ADD_BILAGA,
  OFFERTPREV_ON_DELETE_PAGE,
  OFFERTPREV_ON_HIDE_PAGE,
  OFFERTPREV_ON_GET_BILAGOR,
  OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT,
  OFFERTPREV_ON_ADD_PAGE,
  OFFERTPREV_ON_SET_PRODUCT_QNT,

  ON_GET_OFFERT_PAGE_BASIC,
  ON_GET_OFFERT_PAGE_SIZE_BASIC
}  from '../constants/ActionTypes'


import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from '../store'
import {getEsignering} from 'actions'
import {isUndefined} from 'lodash'

export const addPageWithSection = (page, section, column) => {
  return (dispatch) => {
      dispatch({ type: OFFERTPREV_ON_ADD_PAGE, payload: {page, section, column}})
  }
}
export const loadAutoInputTypes = (types) => {
  return (dispatch) => {
      dispatch({ type: OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES, payload: types})
  }
}
export const loadAutoInputTypesFromLs = () => {
  return (dispatch) => {
      dispatch({ type: OFFERTPREV_ON_LOAD_AUTO_FILL_INPUT_TYPES_FROM_LS, payload: {}})
  }
}
export const setOffertPage = (page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_OFFERT_PAGE_BASIC, payload: {Page:page}});
  }
}
export const setOffertPageSise = (page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_OFFERT_PAGE_SIZE_BASIC, payload: {Page:page}});
  }
}


export const updateInputField = (pageId, sectionId, columnId, rowId, cellId, value) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_UPDATE_INPUT_FIELD, payload: {
      pageId,
      sectionId,
      columnId,
      rowId,
      cellId,
      value
    }})
  }
}
export const updateCheckbox = (pageId, sectionId, columnId, rowId, cellId, value) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_UPDATE_CHECKBOX, payload: {
      pageId,
      sectionId,
      columnId,
      rowId,
      cellId,
      value
    }})
  }
}
// export const addOffert = (offert, file, esignering, docflag) => {
//   return (dispatch) => {
//     const jwt =  JSON.parse(localStorage.token);
//     const formData = new FormData()
//     let offertId = !isUndefined(offert.Offertid) ? offert.Offertid : offertId
//     const esign = !isUndefined(esignering)? esignering: 0
//     const DocFlag = !isUndefined(docflag) ? docflag : 0
//     var pages = new Blob([offert.Pages], { type: 'application/json' });
    
    
//     // formData.append('file', file, file.name)
//     // formData.append('files[]', _pages, _pages.name)

//     const files = [file, pages]
    
    
    

//     formData.append('files[]', file)
//     formData.append('Namn', offert.Namn)
//     formData.append('Afid', offert.Afid)
//     formData.append('Orgnr', offert.Orgnr)
//     formData.append('Userid', offert.Userid)
//     formData.append('Offertid', offertId)
//     formData.append('Kund', offert.Kund)
//     formData.append('Offertvalue', offert.Offertvalue)
//     formData.append('Offertprofit', offert.Offertprofit)
//     formData.append('AvProId', offert.AvProId)
//     formData.append('Esignering', esign)
//     formData.append('DocFlag', DocFlag)
//     formData.append('Pages', offert.Pages)
//     formData.append('_filename', file.name)
//     formData.append('Type', offert.Type)
//     formData.append('Deadline', offert.Deadline)

//     console.log(offert)


//     axios.post('offertPrev/add',
//       formData,
//       {
//         body: {
//           Namn: offert.Namn,
//           Afid: offert.Afid,
//           Orgnr: offert.Orgnr,
//           Userid: offert.Userid,
//           Offertid: offertId,
//           Kund: offert.Kund,
//           Offertvalue: offert.Offertvalue,
//           Offertprofit: offert.Offertprofit,
//           AvProId: offert.AvProId,
//           Esignering: esign,
//           Pages: offert.Pages,
//           _filename: file.name,
//           DocFlag,
//           Type: offert.Type,
//           Deadline: offert.Deadline
//         },
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'Authorization':   `Bearer ${jwt}`
//         }
//       }
//     ).then(({data}) => {
//       console.log(data)
//     if(data.success && esignering === undefined) {
//       dispatch({type: OFFERTPREV_ON_ADD_OFFERT, payload: data})
//       dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'Offert skapad!', show: true, type: 'success'}})
//       history.push('/app/Offert/' + offert.Namn, {Offertid: offertId, DocFlag })
//     } else if(data.success && esignering === 1) {
//       dispatch({type: OFFERTPREV_ON_UPDATE_OFFERT, payload: data})
//       dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'E-signering Skapad!', show: true, type: 'success'}})
//       dispatch(getEsignering(offert.Afid, offert.Userid, data.EId))
//     } else {
//       dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Error!', show: true, type: 'error'}})
//     }
//     dispatch(setLoadingDone())
//     }).catch(err => {
//     dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Offert ej skapad!', show: true, type: 'error'}})
//     dispatch(setLoadingDone())
//     console.log(err)
//     })
//   }
// }


export const addOffert = (offert, file, esignering, docflag) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    const esign = !isUndefined(esignering)? esignering: 0
    const DocFlag = !isUndefined(docflag) ? docflag : 0
    const offertId = !isUndefined(offert.Offertid) ? offert.Offertid : uuidv4()
    var pages = new Blob([offert.Pages], { type: 'application/json' });
    

    console.log(file)
    
    // formData.append('file', file, file.name)
    // formData.append('files[]', _pages, _pages.name)

    const files = [file, pages]
    
    
    

    formData.append('files[]', file)
    formData.append('Namn', offert.Namn)
    formData.append('Afid', offert.Afid)
    formData.append('Orgnr', offert.Orgnr)
    formData.append('Userid', offert.Userid)
    formData.append('Offertid', offertId)
    formData.append('Kund', offert.Kund)
    formData.append('Offertvalue', offert.Offertvalue)
    formData.append('Offertprofit', offert.Offertprofit)
    formData.append('OffertvalueMån', offert.OffertvalueMån)
    formData.append('OffertprofitMån', offert.OffertprofitMån)
    formData.append('AvProId', offert.AvProId)
    formData.append('Esignering', esign)
    formData.append('DocFlag', DocFlag)
    formData.append('Pages', offert.Pages)
    formData.append('_filename', file.name)
    formData.append('Type', offert.Type)
    formData.append('Deadline', offert.Deadline)
    formData.append('id', offert.id)
    formData.append('KontaktID', offert.KontaktID)

    formData.append('ProspektTyp', offert.ProspektTyp)
    formData.append('prospektkalkyl', offert.prospektkalkyl)
    formData.append('Leverantör', offert.Leverantör)

    console.log(offert)


    axios.post('offertPrev/add',
      formData,
      {
        body: {
          id: offert.id,
          Namn: offert.Namn,
          Afid: offert.Afid,
          Orgnr: offert.Orgnr,
          Userid: offert.Userid,
          Offertid: offertId,
          Kund: offert.Kund,
          Offertvalue: offert.Offertvalue,
          Offertprofit: offert.Offertprofit,
          OffertvalueMån: offert.OffertvalueMån,
          OffertprofitMån: offert.OffertprofitMån,
          AvProId: offert.AvProId,
          Esignering: esign,
          Pages: offert.Pages,
          _filename: file.name,
          DocFlag,
          Type: offert.Type,
          Deadline: offert.Deadline,
          KontaktID: offert.KontaktID,

          ProspektTyp: offert.ProspektTyp,
          prospektkalkyl: offert.prospektkalkyl,
          Leverantör: offert.Leverantör
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
    if(data.success && esignering === undefined) {
      dispatch({type: OFFERTPREV_ON_ADD_OFFERT, payload: data})
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'Offert skapad!', show: true, type: 'success'}})
      history.push('/app/Offert/'+String(offert.Namn).replace(/\//g, " "), {Offertid: offert.Offertid, DocFlag })
    } else if(data.success && esignering === 1) {
      dispatch({type: OFFERTPREV_ON_UPDATE_OFFERT, payload: data})
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'E-signering Skapad!', show: true, type: 'success'}})
      dispatch(getEsignering(offert.Afid, offert.Userid, data.EId))
    } else {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Error!', show: true, type: 'error'}})
    }
    dispatch(setLoadingDone())
    }).catch(err => {
    dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Offert ej skapad!', show: true, type: 'error'}})
    dispatch(setLoadingDone())
    console.log(err)
    })
  }
}

export const addOffertUtkast = (afi, offert, selectCustomer, avproid, SKontakt, KontaktID) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    // let offertId = !isUndefined(offert.Offertid) ? offert.Offertid : offertId
    var pages = new Blob([offert.Pages], { type: 'application/json' });
    console.log(SKontakt)
    let Kontakt = null
    try {
      Kontakt = isUndefined(SKontakt) ? null : JSON.stringify(SKontakt)
    } catch {
      Kontakt = null
    }
    
    
    
    // formData.append('file', file, file.name)
    // formData.append('files[]', _pages, _pages.name)

    const files = [pages]
    const offertId = uuidv4()
    
    let Autofill = JSON.stringify(afi)
    
    

    formData.append('files[]', pages)
    formData.append('OldOffertId', isUndefined(offert.OldOffertId) ? 0 : offert.OldOffertId)
    formData.append('Afid', offert.Afid)
    formData.append('Orgnr', offert.Orgnr)
    formData.append('Userid', offert.Userid)
    formData.append('Offertid', offertId)
    formData.append('Kund', offert.Kund)
    formData.append('Pages', offert.Pages)
    formData.append('Type', offert.Type)
    formData.append('Autofill', Autofill)
    formData.append('Kontakt', Kontakt)
    formData.append('KontaktID', KontaktID)

    console.log(offert)


    axios.post('offertPrev/addUtkast',
      formData,
      {
        body: {
          Afid: offert.Afid,
          Orgnr: offert.Orgnr,
          Userid: offert.Userid,
          Offertid: offertId,
          Kund: offert.Kund,
          Pages: offert.Pages,
          Type: offert.Type,
          Autofill: Autofill,
          Kontakt: Kontakt,
          KontaktID: KontaktID,
          OldOffertId: isUndefined(offert.OldOffertId) ? 0 : offert.OldOffertId
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
    if(data.success) {
      // console.log("success")
      
      history.push(
        {
          pathname: '/app/Offert/utkast',
          state: { Offertid: offertId, DocFlag: 0, selectCustomer, id: avproid, afi }
        }
      )
    } else {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Error!', show: true, type: 'error'}})
    }
    dispatch(setLoadingDone())
    }).catch(err => {
    dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Offert ej skapad!', show: true, type: 'error'}})
    dispatch(setLoadingDone())
    console.log(err)
    })
  }
}



export const addBilaga = (pages) => {
  return (dispatch) => {
    dispatch({type: OFFERTPREV_ON_ADD_BILAGA, payload: pages})
  }
}
export const addFile = (id, file, Afid, FileName, Offertid, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    // var pages = new Blob([offert.Pages], { type: 'application/json' });
    

    // const files = [file, pages]

    formData.append('files[]', file)
    formData.append('id', id)
    formData.append('Afid', Afid)
    formData.append('FileName', FileName)
    formData.append('Offertid', Offertid)
    formData.append('Userid', Userid)

    axios.post('offertPrev/addFile',
      formData,
      {
        body: {
          id: id,
          Afid: Afid,
          FileName: FileName,
          Offertid: Offertid,
          Userid: Userid
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      dispatch(getFiles(id, Userid))
      console.log(data)
    }).catch(err => {
    console.log(err)
    })
  }
}
export const getFiles = (id, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getFiles', {params: {id,Userid}, headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_BILAGOR, payload: data})
      // console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeBilagaOffert = (id, FileNameGc, offertId, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('offertPrev/removeFile', {params: {id, FileNameGc, Userid},headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      // dispatch({type: OFFERTPREV_ON_GET_BILAGOR, payload: data})
      dispatch(getFiles(offertId, Userid))
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deletePageOffert = (page) => {
  return (dispatch) => {
    dispatch({type: OFFERTPREV_ON_DELETE_PAGE, payload: page})
  }
}
export const hidePageOffert = (page, hidden) => {
  return (dispatch) => {
    dispatch({type: OFFERTPREV_ON_HIDE_PAGE, payload: {page,hidden}})
  }
}
export const loadOffert = (offertId, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: OFFERTPREV_ON_START_LOAD_OFFERT})
    axios.get('offertPrev/load', {params: {id: offertId, Userid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_LOAD_OFFERT, payload: data[0]})
      dispatch(getFiles(data[0].id, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOfferts = (Afid, Userid, Offset, PageSize, FilterState) => {
  return (dispatch) => {
    dispatch({type: OFFERTPREV_ON_START_GET_ALL_OFFERTS})
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/get', {params: {Afid, Userid, Offset, PageSize,FilterState },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_GET_ALL_OFFERTS, payload: data})
      dispatch(getFiles(data.Offerts[0].id, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const searchOfferts = (Afid, SearchString, Offset, PageSize, FilterState, Userid) => {
  console.log("search")
  return (dispatch) => {
    dispatch({type: OFFERTPREV_ON_START_GET_ALL_OFFERTS})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/search', {params: {Afid, SearchString, Offset, PageSize,FilterState,Userid },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_SEARCH_OFFERTS, payload: data.results})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOffertsCount = (Afid, Userid, FilterState) => {
  return (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/count', { params:{Afid, Userid, FilterState},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_OFFERT_COUNT, payload: data})
      // console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const loadAktivaArtiklar = (Afid,Userid, Orgnr,prisLista) => {
  console.log(prisLista, 'prisLista')
  /*JAck*/
  prisLista = isUndefined(prisLista)?0:prisLista
  /*JAck*/
  return (dispatch) => {
      dispatch({type: OFFERTPREV_ON_START_LOAD_ARTIKLAR})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/loadArt', {params: {id: Afid,Userid, Orgnr
    /*Jack*/
    ,prisLista
    /*Jack*/
    },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
        dispatch({type: OFFERTPREV_ON_LOAD_ARTIKLAR, payload: data.artiklar})
      } else {
        dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      }
    }).catch(err => {
      dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      console.log(err)
    })
  }
}
export const loadAktivaKalkylArtiklar = (Afid, userid,Orgnr) => {
 /**/ return (dispatch) => {
      dispatch({type: OFFERTPREV_ON_START_LOAD_ARTIKLAR})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/loadKalkylArt', {params: {id: Afid,userid, Orgnr},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
        dispatch({type: OFFERTPREV_ON_LOAD_ARTIKLAR, payload: data.artiklar})
      } else {
        dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      }
    }).catch(err => {
      dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      console.log(err)
    })
  }
}
export const loadAktivaKalkylArtiklarJ = (Afid,userid, Orgnr ,prisLista = 0) => {
 /**/ return (dispatch) => {
      dispatch({type: OFFERTPREV_ON_START_LOAD_ARTIKLAR})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/loadKalkylArtJ', {params: {id: Afid,userid, Orgnr,prisLista},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
        dispatch({type: OFFERTPREV_ON_LOAD_ARTIKLAR, payload: data.artiklar})
      } else {
        dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      }
    }).catch(err => {
      dispatch({type: OFFERTPREV_ON_ERROR_LOAD_ARTIKLAR})
      console.log(err)
    })
  }
}

export const deleteOffert = (id, afId, fileName, uid, offset, docflag, orgnr, avproid, PageSize, SearchString, FilterState) => {
  let DocFlag = isUndefined(docflag) ? 0 : docflag
  console.log(DocFlag)
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('offertPrev/delete', { params:{id, Filename: fileName, DocFlag, Userid: uid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(DocFlag === 1 && !isUndefined(orgnr)) {
        dispatch(getDocumentsByOrgnr(orgnr, uid, afId))
      } 
      if(DocFlag === 0 && !isUndefined(orgnr)){
        dispatch(getAllOffertsByOrgnr(orgnr, uid, afId))
        dispatch(getOffertsCountByOrgnr(orgnr, uid, afId)) 
      }
      if(DocFlag === 1 && isUndefined(orgnr) && !isUndefined(avproid)) {
        dispatch(getDocumentsByAvproId(avproid, uid, afId))
      } 
      if(DocFlag === 0 && isUndefined(orgnr) && !isUndefined(avproid)){
        dispatch(getAllOffertsByAvProId(avproid, uid, afId))
        dispatch(getOffertsCountByAvProId(avproid, uid, afId)) 
      }
      if(DocFlag === 0 && isUndefined(orgnr) && isUndefined(avproid)) {
        dispatch({type: OFFERTPREV_ON_DELETE_OFFERT, payload: data})
        dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'Offert #'+id+' borttagen!', show: true, type: 'warning'}})
        if(SearchString === "") {
          dispatch(getOfferts(afId, uid, offset, PageSize, FilterState))
        } else {
          dispatch(searchOfferts(afId, SearchString, offset, PageSize, FilterState, uid))
        }
      }
    }).catch(err => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte ta bort Offert #'+id, show: true, type: 'error'}})
      console.log(err)
    })
  }
}

export const updateOffert = (id, afid, offert, offertTotal, offertProfit,   offertTotalMån, offertProfitMån, file, esignering, docflag, Name, Deadline,prospektkalkyl) => {
  
  const esign = !isUndefined(esignering) ? esignering: 0
  const DocFlag = !isUndefined(docflag) ? docflag: 0
  console.log(docflag)

  const formData = new FormData()
  
  formData.append('files[]', file)
  formData.append('id', id)
  formData.append('Afid', afid)
  formData.append('Filename', offert.DocumentName)
  formData.append('_filename', file.name)
  formData.append('Pages', offert.Pages)
  formData.append('Offertvalue', offertTotal)
  formData.append('Offertprofit', offertProfit)
  formData.append('OffertvalueMån', offertTotalMån)
  formData.append('OffertprofitMån', offertProfitMån)
  formData.append('Esignering', esign)
  formData.append('DocFlag', DocFlag)
  formData.append('Userid', offert.Userid)
  formData.append('AvProId', offert.AvProId)
  formData.append('Orgnr', offert.Orgnr)
  formData.append('KontaktID', offert.KontaktID)
  formData.append('Name', Name)
  formData.append('Deadline', Deadline)
  formData.append('prospektkalkyl', prospektkalkyl)

  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.put('offertPrev/update', 
    formData,
      {
      body: {
        id: id, 
        Userid: offert.Userid,
        AvProId: offert.AvProId,
        Filename: offert.DocumentName, 
        Afid: afid,
        Orgnr: offert.Orgnr,
        Pages: offert.Pages,
        Offertvalue: offertTotal,
        Offertprofit: offertProfit,
        OffertvalueMån: offertTotalMån,
        OffertprofitMån: offertProfitMån,
        Esignering: esign,
        _filename: file.name,
        Name: Name,
        Deadline: Deadline,
        prospektkalkyl: prospektkalkyl,
        KontaktID: offert.KontaktID,
        DocFlag
      },
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }).then(({data}) => {
      console.log(data)
      if(data.success && esignering === undefined) {
        dispatch({type: OFFERTPREV_ON_UPDATE_OFFERT, payload: data})
        dispatch(loadOffert(id,offert.Userid))
        dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'Offert sparad!', show: true, type: 'success'}}) 
      } else if(data.success && esignering === 1) {
        dispatch({type: OFFERTPREV_ON_UPDATE_OFFERT, payload: data})
        dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: 'E-signering skapad!', show: true, type: 'success'}})
        dispatch(getEsignering(afid, offert.Userid, data.EId))
      } else {
        dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Error!', show: true, type: 'error'}})
      }
      dispatch(setLoadingDone())
    }).catch(err => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: false, msg: 'Offert ej sparad!', show: true, type: 'error'}})
      console.log(err)
    })
  }
}

export const mapInputs = (inputs) => {
  return (dispatch) => {
    console.log(inputs)
    dispatch({type: OFFERTPREV_ON_MAP_INPUTS, payload: inputs})
  }
}

export const updateMapInput = (input) => {
  return (dispatch) => {
    console.log(input)
    dispatch({type: OFFERTPREV_ON_UPDATE_MAP_INPUTS, payload: input})
  }
}
export const updateEditText = (value, pageId, sectionId, columnId) => {
  return (dispatch) => {
    console.log(value)
    dispatch({type: OFFERTPREV_ON_CHANGE_EDIT_TEXT, payload: {value, pageId, sectionId, columnId}})
  }
}

export const setCurrentKund = (kund) => {
  return (dispatch) => {
    console.log(kund)
    dispatch({type: OFFERTPREV_ON_SET_CUSTOMER, payload: kund})


  }
}
export const loadCurrentKund = () => {
  return (dispatch) => {
    dispatch({type: OFFERTPREV_LOAD_SELECTED_CUSTOMER, payload: {}})
  }
}

export const resetResponseDataOffert = () => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_RESPOSE_RESET, payload: {}})
  }
}
export const setLoading = (msg) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_SET_LOADING, payload: msg})
  }
}
export const setLoadingDone = () => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_SET_LOADING_DONE, payload: {}})
  }
}

export const addProduct = (product, pageId, sectionId, columnId) => {
  return async (dispatch) => {
    await dispatch({ type: OFFERTPREV_ON_ADD_PRODUCT, payload: {product, pageId, sectionId, columnId}})
    await dispatch({ type: OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT, payload: {}})
    dispatch(sumTotalValue())
  }
}
export const changeAvtalsTid = (AvtalsTid, pageId, sectionId, columnId) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_CHANGE_AVTALSTID, payload: {AvtalsTid, pageId, sectionId, columnId}})
  }
}

export const deleteProduct = (product, pageId, sectionId, columnId) => {
  return async (dispatch) => {
    await dispatch({ type: OFFERTPREV_ON_DELETE_PRODUCT, payload: {product, pageId, sectionId, columnId}})
    await dispatch({ type: OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT, payload: {}})
    dispatch(sumTotalValue())
  }
}
export const changeQnt = (change, product, pageId, sectionId, columnId) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_CHANGE_PRODUCT_QNT, payload: {change, product, pageId, sectionId, columnId}})
    dispatch(sumTotalValue())
  }
}
export const changeQntNew = (change, product, pageId, sectionId, columnId) => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_SET_PRODUCT_QNT, payload: {change, product, pageId, sectionId, columnId}})
    dispatch(sumTotalValue())
  }
}
export const changeProduct = (product, pageId, sectionId, columnId) => {
  return async (dispatch) => {
    await dispatch({ type: OFFERTPREV_ON_CHANGE_PRODUCT, payload: {product, pageId, sectionId, columnId}})
    await dispatch({ type: OFFERTPREV_ON_CHECK_TOTAL_SECTIONS_HEIGHT, payload: {}})
    dispatch(sumTotalValue())
  }
}
export const sumTotalValue = () => {
  return (dispatch) => {
    dispatch({ type: OFFERTPREV_ON_SUM_TOTAL, payload: {}})
  }
}


export const getOffertsByAvProId = (AvProId, Userid, Afid, Offset) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByAvProId', {params: {AvProId, Userid, Afid, Offset },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_AVTAL_OFFERTS, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOffertsCountByAvProId = (AvProId, Userid, Afid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByAvProIdCount', { params:{AvProId, Userid, Afid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_OFFERT_COUNT, payload: data})
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOffertsByOrgnr = (Orgnr, Userid, Afid, Offset,type,seachWord) => {
  // console.log('TEST---------')
  type = isUndefined(type)?3:type
  seachWord = isUndefined(seachWord)?"":seachWord
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByOrgnr', {params: {Orgnr, Userid, Afid, Offset,type,seachWord },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_OFFERTS, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getAllOffertsByOrgnr = (Orgnr, Userid, Afid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByOrgnrAll', {params: {Orgnr, Userid, Afid },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      dispatch({type: OFFERTPREV_ON_GET_OFFERTS, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getAllOffertsByAvProId = (AvProId, Userid, Afid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByAvProIdAll', {params: {AvProId, Userid, Afid },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      dispatch({type: OFFERTPREV_ON_GET_OFFERTS, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOffertsCountByOrgnr = (Orgnr, Userid, Afid,type,seachWord) => {
  type = isUndefined(type)?3:type
  seachWord = isUndefined(seachWord)?"":seachWord
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/getByOrgnrCount', { params:{Orgnr, Userid, Afid,type,seachWord},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_OFFERT_COUNT, payload: data})
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getDocumentsByOrgnr = (Orgnr, Userid, Afid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('document/getByOrgnr', { params:{Orgnr, Userid, Afid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_GET_DOCUMENTS, payload: data})
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getDocumentsByAvproId = (AvProId, Userid, Afid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('document/getByAvProIdAll', { params:{AvProId, Userid, Afid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      dispatch({type: OFFERTPREV_ON_GET_DOCUMENTS, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const loadDocument = (docid, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: OFFERTPREV_ON_START_LOAD_OFFERT})
    axios.get('document/load', {params: {id: docid, Userid},headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_LOAD_OFFERT, payload: data[0]})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getOffertStats = (Afid, Userid, AllOfferts) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/stats', {params: {Afid, Userid, AllOfferts }
    ,headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    } 
  }).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_GET_STATS, payload: data})
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

export const fetchArt = (id, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('offertPrev/fetchArt', {params: {id,Userid },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_FETCH_ART, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const searchArt = (Afid, SearchString,Userid, Orgnr, prisLista = 0) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: OFFERTPREV_ON_START_SEARCH_ART})
    axios.get('offertPrev/searchArt', {params: {Afid, SearchString,Userid,Orgnr,prisLista },headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: OFFERTPREV_ON_RESPOSE, payload: {success: true, msg: '', show: false, type: 'success'}})
      dispatch({type: OFFERTPREV_ON_SEARCH_ART, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}
//Jack 
//updateOffertStatus
export const updateOffertStatus =  (Afid,userid,OffertId,newStatus,type) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_OFFERT_UPDATE_STATUS});
    axios.put('docTemplate/Status/update', {
      method: 'PUT',
      body: {
        Afid:Afid,
        userid:userid,
        OffertId:OffertId,
        newStatus:newStatus,
        type
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }
    }).then(({data}) => {
      if (data.results) {
        if(parseInt(type) === 1){
          dispatch({type: ON_OFFERT_UPDATE_STATUS, payload: data.results});
        }
        if(parseInt(type) === 2){
          dispatch({type: ON_OFFERT_UPDATE_STATUS_1, payload: data.results});
        }
        if(parseInt(type) === 3){
          dispatch({type: ON_OFFERT_UPDATE_STATUS_2, payload: data.results});
        }
        if(parseInt(type) === 4){
          dispatch({type: ON_OFFERT_UPDATE_STATUS_3, payload: data.results});
        }
        if(parseInt(type) === 5){
          dispatch({type: ON_OFFERT_UPDATE_STATUS_4, payload: data.results});
        }
        
      }else{
        dispatch({type: ON_ERROR_OFFERT_UPDATE_STATUS, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_OFFERT_UPDATE_STATUS, payload: error.message});
    })
        
  }
}
//

